import {
  cookieConsent,
  denyCookieConsent,
  grantCookieConsent,
} from '@/services/consent'
import { aria, attr, html, on, When } from '@tempots/dom'

/**
 * Analytics-consent banner, shown until the visitor decides. Analytics
 * providers only load after a grant (see track.ts); declining keeps the
 * app fully functional with no analytics cookies at all.
 */
export function CookieConsentBanner() {
  return When(
    cookieConsent.map(consent => consent == null),
    () =>
      html.div(
        attr.class(
          'fixed bottom-0 inset-x-0 z-50 border-t border-gray-200 bg-white/95 backdrop-blur px-4 py-3 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]'
        ),
        attr.role('dialog'),
        aria.label('Cookie consent'),
        html.div(
          attr.class(
            'mx-auto max-w-4xl flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-gray-700'
          ),
          html.span(
            'We use cookies for analytics to understand how ResumeHeaders is used and improve it. See our ',
            html.a(
              attr.href('/privacy'),
              attr.class('text-teal-700 underline hover:text-teal-800'),
              'privacy policy'
            ),
            '.'
          ),
          html.div(
            attr.class('flex items-center gap-2'),
            html.button(
              attr.type('button'),
              attr.class(
                'rounded-md bg-teal-700 px-3 py-1.5 text-sm font-semibold text-white hover:bg-teal-800'
              ),
              on.click(grantCookieConsent),
              'Accept'
            ),
            html.button(
              attr.type('button'),
              attr.class(
                'rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50'
              ),
              on.click(denyCookieConsent),
              'Decline'
            )
          )
        )
      )
  )
}
